<template>
  <div class="jmfsSk" style="height: 0px;">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
          查进面分数 - 省考
        </el-text>
      </el-form-item>
    </el-form>
        
    <el-row :gutter="40">
      <el-col :span="6">
        <el-form class="form" label-width="auto">
          <el-form-item label="第1步：省份选择">
            <el-button type="primary" @click="show.addProvince = true" style="margin-left: 20px;">添加省份</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="data.provinces" border style="width: 100%; height: calc(100vh - 200px);" @row-click="(row) => { data.province = row.kkey; provinceChange() }">
          <el-table-column prop="kkey" label="省份" align="center" />
          <el-table-column label="操作" width="100" align="center">
            <template #default="scope">
              <el-button size="small" type="danger" @click="() => { data.province = scope.row.kkey; show.delProvince = true; }">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="6">
        <el-form class="form" label-width="auto">
          <el-form-item label="第2步：选择年份">
            <el-button type="primary" @click="show.addYear = true" style="margin-left: 20px;">添加年份</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="data.years" border style="width: 100%; height: calc(100vh - 200px);" @row-click="(row) => { data.year = row.kkey; yearChange() }">
          <el-table-column prop="kkey" label="年份" align="center" />
          <el-table-column label="操作" width="100" align="center">
            <template #default="scope">
              <el-button size="small" type="danger" @click="() => { data.year = scope.row.kkey; show.delYear = true; }">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="12">
        <el-form class="form" label-width="auto">
          <el-form-item label="第3步：上传省考进面分数">
            <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
              {{ data.province }} {{ data.year }}
            </el-text>
          </el-form-item>
          <template v-if="data.province && data.year">
            <el-form-item label="">
              <el-upload :data="{ type: 'JMFS_SK', kkey1: data.province, kkey2: data.year }" style="width: 100%;" v-model:file-list="data.file.jmfs_sk" :limit="1" :action="api.baseURL() + '/backend/information/importExcel'" :headers="api.tokenHeader()"
                multiple drag :on-success="() => ElMessage.success('保存成功')" :on-error="() => ElMessage.error('上传失败')" :on-preview="(f) => util.previewElfile(f)" :on-remove="remove1" accept=".xls,.xlsx">
                <el-text>点击或拖转到此处上传文件（最多1个）</el-text>
              </el-upload>
            </el-form-item>
          </template>
          <template v-if="!data.province || !data.year">
            <el-text>请先选择省份和年份</el-text>
          </template>
        </el-form>
      </el-col>
    </el-row>
    <div style="height: 10px;"></div>
  </div>

  <el-dialog v-model="show.addYear" title="添加年份" width="30%">
    <el-form :model="data" label-width="auto">
      <el-form-item label="请输入年份">
        <el-input-number v-model="data.addYear.kkey" placeholder="请输入年份" :min="1900" :max="2100" :controls="false" style="width: 100%"/>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="show.addYear = false">取消</el-button>
        <el-button type="primary" @click="addYear">确定</el-button>
      </span>
    </template>
  </el-dialog>

  <el-dialog v-model="show.delYear" title="删除年份" width="30%">
    <el-text>确定删除 {{ data.province }} 的 {{ data.year }} 年份？</el-text>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="show.delYear = false">取消</el-button>
        <el-button type="primary" @click="delYear">确定</el-button>
      </span>
    </template>
  </el-dialog>

  <el-dialog v-model="show.addProvince" title="添加省份" width="30%">
    <el-form :model="data" label-width="auto">
      <el-form-item label="请输入省份名称">
        <el-select v-model="data.addProvince.kkey" filterable style="width: 100%">
          <el-option v-for="item in provinces" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="show.addProvince = false">取消</el-button>
        <el-button type="primary" @click="addProvince">确定</el-button>
      </span>
    </template>
  </el-dialog>

  <el-dialog v-model="show.delProvince" title="删除省份" width="30%">
    <el-text>确定删除 {{ data.province }} ？</el-text>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="show.delProvince = false">取消</el-button>
        <el-button type="primary" @click="delProvince">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import Editor from '../../components/Editor.vue'

const router = useRouter()
const show = reactive({
  addYear: false,
  delYear: false,
  addProvince: false,
  delProvince: false,
})
const provinces = reactive(["北京市", "天津市", "河北省", "山西省", "内蒙古自治区", "辽宁省", "吉林省", "黑龙江省", "上海市", "江苏省", "浙江省", "安徽省", "福建省", "江西省", "山东省", "河南省", "湖北省", "湖南省", "广东省", "广西壮族自治区", "海南省", "重庆市", "四川省", "贵州省", "云南省", "西藏自治区", "陕西省", "甘肃省", "青海省", "宁夏回族自治区", "新疆维吾尔自治区", "台湾省", "香港特别行政区", "澳门特别行政区"])
const data = reactive({
  years: [],
  year: '',
  addYear: {},
  provinces: [],
  province: '',
  addProvince: {},
  file: { file: [] },
})

/** 查询年份 */
const getYears = () => {
  api.get('/backend/kkv/getList', {
    params: {
      scene: 'JMFS_SK_Y' + data.province
    }
  }).then((res) => {
    if (res && res.list && res.list.length > 0) {
      data.years = res.list
      if (res.list.length > 0) {
        data.year = res.list[0].kkey
        yearChange()
      } else {
        data.year = ''
      }
    } else {
      data.years = []
      data.year = ''
    }
  })
}

/** 查询全部省份 */
const getProvinces = () => {
  api.get('/backend/kkv/getList', {
    params: {
      scene: 'JMFS_SK_P'
    }
  }).then((res) => {
    if (res && res.list && res.list.length > 0) {
      data.provinces = []
      provinces.forEach((item) => {
        for (const i of res.list) {
          if (i.value === item) {
            data.provinces.push(i)
            break
          }
        }
      })
      if (!data.province) {
        data.province = res.list[0].kkey
        provinceChange()
      }
    } else {
      data.provinces = []
      data.province = ''
    }
  })
}
getProvinces()

/** 添加年份 */
const addYear = () => {
  if(!data.province){
    ElMessage.error('请先选择省份')
    return
  }
  api.post('/backend/kkv/put', {
    scene: 'JMFS_SK_Y' + data.province,
    kkey: data.addYear.kkey,
    value: data.addYear.kkey
  }).then(() => {
    ElMessage.success('添加成功')
    data.addYear = {}
    show.addYear = false
    getYears()
  })
}

/** 添加省份 */
const addProvince = () => {
  api.post('/backend/kkv/put', {
    scene: 'JMFS_SK_P',
    kkey: data.addProvince.kkey,
    value: data.addProvince.kkey
  }).then(() => {
    ElMessage.success('添加成功')
    data.addProvince = {}
    show.addProvince = false
    getProvinces()
  })
}

const delYear = () => {
  if (!data.province) {
    ElMessage.error('请先选择省份')
    return
  }
  api.post('/backend/kkv/del', {
    scene: 'JMFS_SK_Y' + data.province,
    kkey: data.year,
  }).then(() => {
    data.year = ''
    show.delYear = false
    ElMessage.success('删除成功')
    getYears()
  })
}

const delProvince = () => {
  api.post('/backend/kkv/del', {
    scene: 'JMFS_SK_P',
    kkey: data.province,
  }).then(() => {
    data.province = ''
    show.delProvince = false
    ElMessage.success('删除成功')
    getProvinces()
  })
}

/** 切换年份 */
const yearChange = () => {
  data.file.jmfs_sk = []
  api.get('/backend/kkv/getList', {
    params: {
      scene: 'JMFS_SK'
    }
  }).then((res) => {
    if (res && res.list && res.list.length > 0) {
      const kkv = res.list.find((item) => item.kkey === data.province + data.year)
      if (kkv && kkv.value) {
        data.file.jmfs_sk = util.json2Elfile(JSON.stringify([kkv.value]))
      }
    }
  })
}

/** 切换省份 */
const provinceChange = () => {
  data.year = ''
  getYears()
}

const remove1 = () => {
  api.post('/backend/information/remove', {
    type: 'JMFS_SK',
    kkey1: data.province,
    kkey2: data.year,
  }).then(() => {
    ElMessage.success('删除成功')
  })
}

</script>

<style lang="less">
.jmfsSk {
  margin: auto;

  .avatar-uploaded {
    width: 178px;
    height: 178px;
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    margin-right: 20px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
  }

  .avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
  }

  .el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
  }
}
</style>